import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './icofont.min.css';
import App from './App';
import reportWebVitals from './reportWebVitals';


// type SquareProps = {
//   value: null | string;
//   onclick: () =>  void;
// }
// type SquareState = {
//   value: null | string
// }

// type BoardT = {
//   squares: (null | string)[]
// }

// function calculateWinner(squares:(null| string)[]) {
//   const lines = [
//     [0, 1, 2],
//     [3, 4, 5],
//     [6, 7, 8],
//     [0, 3, 6],
//     [1, 4, 7],
//     [2, 5, 8],
//     [0, 4, 8],
//     [2, 4, 6],
//   ];
//   for (let i = 0; i < lines.length; i++) {
//     const [a, b, c] = lines[i];
//     if (squares[a] && squares[a] === squares[b] && squares[a] === squares[c]) {
//       return squares[a];
//     }
//   }
//   return null;
// }

// function Square(props:SquareProps) {
//     return (
//       <button className="square" onClick={props.onclick}>
//         {props.value}
//       </button>
//     );
// }


// interface BoardProps {
//   squares:(null|string)[];
//   xIsNext:boolean;
//   onclick:(i:number) => void;
//   history:BoardT[];
//   jumpTo:(i:number) => void;
// }

// class Board extends React.Component<BoardProps> {
  
//   renderSquare(i:number) {
//     return <Square value={this.props.squares[i]} onclick={() => this.props.onclick(i)}/>;
//   }

//   render() {
   
//     let status;
//     const winner = calculateWinner(this.props.squares);
//     if (winner) {
//       status = `Winner: ${winner}`;
//     } else {
//       status = `Next player: ${this.props.xIsNext ? 'X': 'O'}`;
//     }

//     const moves = this.props.history.map((step, move) => {
//       const desc = move ? `Go to move #${move}`: `Go to start`;
//       return (<li key={move}><button onClick={() => this.props.jumpTo(move)}> {desc}</button></li>)
//     })

//     return (
//       <div>
//         <div className="status">{status}</div>
//         <ol>{moves}</ol>
//         <div className="board-row">
//           {this.renderSquare(0)}
//           {this.renderSquare(1)}
//           {this.renderSquare(2)}
//         </div>
//         <div className="board-row">
//           {this.renderSquare(3)}
//           {this.renderSquare(4)}
//           {this.renderSquare(5)}
//         </div>
//         <div className="board-row">
//           {this.renderSquare(6)}
//           {this.renderSquare(7)}
//           {this.renderSquare(8)}
//         </div>
//       </div>
//     );
//   }
// }

// class Game extends React.Component {
//   state: {history: BoardT[], xIsNext: boolean, stepNumber: number}
//   constructor(props:{}) {
//     super(props);
//     this.state = {
//       history: [
//         {squares: Array(9).fill(null)}
//       ],
//       xIsNext: true,
//       stepNumber: 0,
//     }
//   }
//   jumpTo(move:number) {
//     this.setState({
//       stepNumber: move,
//       xIsNext: (move % 2) === 0,
//     })
//   }
//   handleCLick(i:number):void {
//     const history = this.state.history.slice(0, this.state.stepNumber + 1);
//     const squares = history[history.length - 1].squares.slice();

//     if (calculateWinner(squares) || squares[i]) {
//       return;
//     }
//     squares[i] = this.state.xIsNext ? 'X': 'O';
//     this.setState({history: history.concat([{squares:squares}]), xIsNext: !this.state.xIsNext, stepNumber: history.length});
//   }
  
//   render() {
//     const squares = this.state.history[this.state.stepNumber].squares
//     return (
//       <div className="game">
//         <div className="game-board">
//           <Board history={this.state.history} jumpTo={(move:number) => this.jumpTo(move)} squares={squares} xIsNext={this.state.xIsNext} onclick={(i:number) => this.handleCLick(i)} />
//         </div>
//         <div className="game-info">
//           <div>{/* status */}</div>
//           <ol>{/* TODO */}</ol>
//         </div>
//       </div>
//     );
//   }
// }

// ========================================

ReactDOM.render(
  <React.StrictMode>
  <App />
  </React.StrictMode>,
  document.getElementById('root') as HTMLElement
);


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
